import { getDataOfConfigSteamsTypes, consoleLog } from './utilsStreamTypesConfig';

export const getConfigSS = (options) => {
    console.log('=> PAU LOADMEDIA ES SS');

    const { src, poster, server_url, device_id } = getDataOfConfigSteamsTypes(options);

    const challenge = (options.drmInfo && options.drmInfo.challenge) || null;
    let customData = null;
    let _header = null;
    let playreadyConfig = null;

    if (challenge && server_url) {
        if (challenge && challenge.indexOf('tokenID') !== -1) {
          playreadyConfig = {
              playready: {
                LA_URL: server_url,
                headers: {
                  'Content-Type': 'text/xml'
                },
                utf8message: true,
                plaintextChallenge: true
            }
          }
        } else {
            const _challenge = JSON.parse(challenge);
            // Esta es la forma que se envía el token por customdata base 64 pero no jala en web0s en contenidos amco
            //customData = btoa(`{"customdata":${challenge},"device_id": "${device_id}"}`);
            // Este es el custom data para header
            customData = btoa(JSON.stringify({ token: _challenge.token, device_id: device_id }));
            _header = {
                'X-DRM-Message': customData,
                'Content-Type': 'text/xml',
            };
            playreadyConfig = {
                playready: {
                    LA_URL: server_url,
                    headers: _header,
                    utf8message: true,
                    plaintextChallenge: true,
                },
            };
        }
    }

    consoleLog('=> PAU server_url: ' + server_url);
    consoleLog('=> PAU video_url: ' + src);
    consoleLog('=> PAU challenge: ' + challenge);
    consoleLog('=> PAU customData: ' + customData);

    const config = {
        title: '',
        description: '',
        poster,
        smooth: src,
        drm: playreadyConfig ? playreadyConfig : {},
    };

    return config;
};



// WEBPACK FOOTER //
// ./src/devices/all/bitmovin/utils/streams-types-config/smoothStream.js